module.exports = __webpack_public_path__ + "assets/images/infoicon.8699d145b4985b6a964c1f55f3af68a8.svg";